/**
 * 로그인·가입 화면으로 보내면서 돌아올 곳(`next`)을 들려 보내는 경로.
 *
 * 한 곳에서만 조립한다 — 화면마다 문자열을 만들면 인코딩을 빠뜨린 곳이 하나쯤 생기고,
 * 그 화면에서만 `?download=…` 같은 뒷부분이 잘려 나간다. 자료를 받으러 로그인한 사람이
 * 자료 앞이 아니라 자료실 첫 화면에 떨어지는 것이 바로 그 증상이다.
 *
 * 받는 쪽(`/login`·`/signup`)은 이 값을 `toInternalPath` 로 다시 검사한다 — 주소창의 값이라
 * 그대로 믿지 않는다.
 */
const LOGIN_PATH = '/login';
const SIGNUP_PATH = '/signup';
const NEXT_PARAM = 'next';

const withNext = (path: string, next: string): string =>
  `${path}?${NEXT_PARAM}=${encodeURIComponent(next)}`;

export function loginPathWithNext(next: string): string {
  return withNext(LOGIN_PATH, next);
}

/** 가입만 시키고 자료를 안 주면 게이트가 아니라 장벽이 된다 — 가입 경로도 next 를 들고 간다. */
export function signupPathWithNext(next: string): string {
  return withNext(SIGNUP_PATH, next);
}
